import type * as BrazeWebSdk from '@braze/web-sdk'

export type BrazeSdk = typeof BrazeWebSdk
export const loadBrazeSdk = async (): Promise<BrazeSdk> =>
  await import('@braze/web-sdk')
